import React, { useState, useRef, useEffect, Fragment, useMemo } from "react";
import "./../../propertycompreport/components/Report.scss";
import { _hasPermission } from "../../../../../../shared/helpers/access";
import { _axiosCall } from "../../../../../../shared/helpers/apicalls";
import moment from "moment";
import Cards from "../../propertycompreport/components/Cards";
import Bar from "../../propertycompreport/components/Bar";
import MultipleBarCharts from "../../propertycompreport/components/MultipleBarCharts";
import MultipleLineCharts from "../../propertycompreport/components/MultipleLineCharts";
import "../../propertycompreport/components/Report.scss";
import FeatureIcon from "mdi-react/CheckCircleOutlineIcon";
import Icon from "../../propertycompreport/components/Icon.jsx";
import CryptoJS from "crypto-js";

import {
  _capitalizeText,
  _formatNumber,
  _formatPrice,
  _formatCurrency,
  _nameToUrl,
  _shouldShow,
  _getBuildingURL,
  _replaceAbbreviations,
  _formatBed,
  _isEqual,
  _tranformTagsQuery,
  _isNewUser,
  _isEnterpriseUser,
  _objectEqual,
  getCohortQuery,
  _activityFQ,
  _isHouse,
  _formatBigPrice,
  _activityFL,
  _getFeaturesArr,
  _chunkArray,
  _isCoop,
  _validUnitSources,
  propertyExportFL,
  propertyFL,
  _formatNum,
  _getBuildingPhotos,
  _getServiceLevel,
  _checkBuildingAltAdr,
  _calPercentage,
  _checkFieldForValue,
  _privateKey,
  _slugifyText
} from "../../../../../../shared/helpers/utils";
import { amenitiesList } from "../../../../../../shared/helpers/bp-utils.js";
import { userEditFieldsObj } from "../../../../../../shared/helpers/userEditFields.js";
import {
  generatePeriodNames,
  prepareResForAI,
  filterAIData,
  getCurrentPeriod,
  getPriorPeriod,
  getRangeEnd,
  getRangeStart,
  formatDate,
  validateNestedData,
  formatDateRange,
  percentageChange,
  roundUpToNearest
} from "../../../exportreport/utils";
import CustomTable from "../../components/CustomTable";
import CustomBarChart from "../../propertycompreport/components/CustomBarChart";
import { height } from "@material-ui/system";
import Amenities from "../../propertycompreport/components/Amenities";
import { building } from "../../../../../DataExport/components/EmptyExportList/components/EmptyList";
import { formValues } from "redux-form";
import Footer from "./../../reports/components/Footer";
import CircularProgress from "../../propertycompreport/components/CircularProgress.jsx";
import SubHeader from "../../propertycompreport/components/SubHeader.jsx";
import CustomLineChart from "../../propertycompreport/components/CustomLineChart.jsx";
import CustomSkeleton from "../../propertycompreport/components/Skeleton.jsx";
import { calculateAverages, openAIModel, parseEditedHTML } from "../../../exportreport/utils";
import { getRentalDerived, formatRentalPropertyData, formatRent, formatRentPSF } from "../../../exportreport/rentalCompUtils";
import PropertyCard from "./../../propertycompreport/components/PropertyCard"; // removed
import CoverPage from "./../../reports/components/CoverPage";

const apiURL = process.env.API_ROOT;

let statTypes = [
  {
    key: "residential_sales",
    title: "Condo, Co-op and Single-Family Homes",
    name: "Market Overview",
    checkedColor: "#D5E1A3",
    activitesQuery: "event_tags:(condo* co?op* coop* condo*p single?family)",
    default: true
  },
  {
    key: "condo",
    title: "New and Resale Condos",
    name: "Condo",
    checkedColor: "#780F9E",
    activitesQuery:
      '(event_tags:(condo* !condo*p) AND -address_2_normalized:"")',
    default: true
  },
  {
    key: "coop",
    title: "New and Resale Co-ops",
    name: "Co-op",
    checkedColor: "#28C2FF",
    activitesQuery:
      '(event_tags:(co?op* coop* condo*p) AND -address_2_normalized:"")',
    default: true
  },
  {
    key: "single_family",
    title: "Townhouses and Detached Single-Family Homes",
    name: "Single-Family",
    checkedColor: "#FFD23F",
    activitesQuery: "(event_tags:(single?family))"
  }
];

let MIN_COUNT = 10;

const generateShareLink = property => {
  if (!property || !property.building || !property.key) return false;
  var building_slug = property.building.substr(4);
  var shareBaseURL = "https://share.marketproof.com/building/";
  var encryptedBuildingSlug = btoa(
    CryptoJS.AES.encrypt(building_slug, _privateKey)
  );
  var shareLink = building_slug;
  if (property && property.address_2_normalized) {
    shareBaseURL = "https://share.marketproof.com/unit/";
    shareLink =
      building_slug + "/" + _slugifyText(property.address_2_normalized);
  }
  shareLink = btoa(CryptoJS.AES.encrypt(shareLink, _privateKey));
  return shareBaseURL + shareLink;
};

const BlendedLayout = props => {
  const {
    fetchInProgress,
    setFetchInProgress,
    user,
    reportLoaded,
    setReportLoaded,
    reportData,
    setReportData,
    searchTags,
    summarizeGeographies,
    customDate,
    submit,
    setSubmit,
    color,
    theme,
    compSettings,
    setAiResponse,
    AiResponse,
    setFetchAi,
    fetchAi,
    setAIInProgress,
    editedContent = ""
  } = props;

  const editedMap = useMemo(() => parseEditedHTML(editedContent), [editedContent]);

  function renderEditedOrDefault(id, fallback) {
    // When comps changed with "Update Suggested Price", all comp-derived
    // values are stale — always use fresh computed values.
    if (reportData && reportData.updateSuggestedPrice) {
      return fallback;
    }
    if (!editedMap || !editedMap[id]) return fallback;
    try {
      var parser = new DOMParser();
      var doc = parser.parseFromString(editedMap[id], "text/html");
      var el = doc.body.firstElementChild;

      if (el && el.getAttribute("data-changed") === "true") {
        var tag = el.tagName.toLowerCase();
        var props = toReactProps(el);
        props.dangerouslySetInnerHTML = { __html: el.innerHTML };
        return React.createElement(tag, props);
      }
    } catch (e) {
      console.warn("Failed to parse edited HTML for id:", id, e);
    }
    return fallback;
  }

  function toReactProps(el) {
    var props = {};
    for (var i = 0; i < el.attributes.length; i++) {
      var attr = el.attributes[i];
      var name = attr.name;
      var value = attr.value;

      if (name === "class") name = "className";
      else if (name === "for") name = "htmlFor";
      else if (name === "style") {
        props.style = cssTextToObject(value);
        continue;
      }
      props[name] = value;
    }
    return props;
  }

  function cssTextToObject(cssText) {
    var style = {};
    if (!cssText) return style;
    var parts = cssText.split(";");
    for (var i = 0; i < parts.length; i++) {
      var pair = parts[i];
      var idx = pair.indexOf(":");
      if (idx === -1) continue;
      var key = pair.slice(0, idx).trim().replace(/-([a-z])/g, function (_, c) { return c.toUpperCase(); });
      var val = pair.slice(idx + 1).trim();
      if (key) style[key] = val;
    }
    return style;
  }

  const { dateOptions } = customDate;
  const currentPeriod = getCurrentPeriod(dateOptions);
  const priorPeriod = getPriorPeriod(dateOptions);
  const priorYearPeriod = priorPeriod;
  const rangeEnd = getRangeEnd(dateOptions);
  const rangeStart = getRangeStart;
  const gap = dateOptions.gap;
  const currentPeriodName = generatePeriodNames(dateOptions).currentPeriod;
  const priorYearPeriodName = generatePeriodNames(dateOptions).priorYearPeriod;

  useEffect(() => {
    if (!reportData && !fetchInProgress && submit) {
      const fetchData = async () => {
        await loadData();
      };
      fetchData();
      setSubmit(false);
    }
  }, [submit]);

  useEffect(() => {
    // debug only
    // console.log(reportData, fetchAi)
  }, [reportData, fetchAi]);

  useEffect(() => {
    const fetchAIData = async () => {
      setFetchAi && setFetchAi(false);
      setAIInProgress(true);
      const aiResponse = await handleAIGenerate(reportData);
      setAiResponse && setAiResponse(aiResponse);
      setAIInProgress(false);
    };
    if (reportData && fetchAi) {
      fetchAIData();
    }
  }, [reportData, fetchAi]);

  const getLastMonthsQuery = (fieldName, months) => {
    const now = Math.floor(Date.now() / 1000);
    const monthsAgo = now - months * 30 * 24 * 60 * 60;
    return fieldName + ":[" + monthsAgo + " TO " + now + "]";
  };

  const loadData = async () => {
    const addressQ = compSettings.selectedBuilding.alternate_addresses.join(
      '" OR "'
    );
    let q =
      'alternate_addresses:("' +
      addressQ +
      '") AND (zip:' +
      compSettings.selectedBuilding.zip +
      ' OR borough:"' +
      compSettings.selectedBuilding.borough.toLowerCase() +
      '")';
    const fq = ["deleted:false"];

    setFetchInProgress(true);

    let axiosData = {
      url: apiURL + "/query/we3-buildings?cache=60",
      method: "post",
      query: {
        q: q,
        wt: "json",
        fl:
          "key,display_full_street_address,name,alternate_addresses,geocode,borough,neighborhood,markets_major,zip,floors,inventory_total,year_built,year_converted,building_service_level,building_access,amenities_health,ownership_type,total_units,building_style,building_status",
        fq: fq,
        rows: 1
      }
    };

    let res = await _axiosCall(axiosData)
      .then(async res => {
        if (res && res.docs && res.docs[0]) {
          let building = res.docs[0];

          if (building.ownership_type && building.ownership_type.toLowerCase().indexOf("co-op") !== -1) {
            building.ownership_type = "coop";
          }
          if (building.ownership_type && building.ownership_type.toLowerCase().indexOf("condop") !== -1) {
            building.ownership_type = "condop";
          }

          const compResponse = await getComps(building);

          let theReportData = { buildingRes: building, compResponse, compSettings };
          const derivedData = getRentalDerived(theReportData);
          theReportData["derivedData"] = derivedData;

          setReportData(theReportData);
        }
        return res;
      })
      .catch(error => {
        console.log("error: " + error);
      })
      .finally(() => {
        setFetchInProgress(false);
        setReportLoaded(true);
        setSubmit(false);
        setFetchAi && setFetchAi(true);
      });
  };

  const handleAIGenerate = async theReportData => {
    const { buildingRes, derivedData, compResponse, compSettings, updateSuggestedPrice } = theReportData;
    const {
      subjectProperty,
      activeComps,
      avgActiveComps,
      soldComps,
      avgSoldComps,
      activityResponse
    } = derivedData;
    const { ppsfTrends } = compResponse;

    // First neighborhood only — getRentTrends queries neighborhood[0], so naming the whole array
    // ("Tribeca,Soho") would label the chart with a geography the data does not cover.
    const hood = buildingRes && Array.isArray(buildingRes.neighborhood) && buildingRes.neighborhood.length > 0
      ? _capitalizeText(buildingRes.neighborhood[0])
      : (buildingRes && buildingRes.neighborhood ? _capitalizeText(buildingRes.neighborhood) : "the neighborhood");

    var subjectCompData = [];
    if (avgActiveComps && avgActiveComps["avgPrice"]) {
      subjectCompData.push("active rental comps avg monthly rent: " + Math.round(avgActiveComps["avgPrice"]));
      if (avgActiveComps["avgPPSF"]) subjectCompData.push("active rental comps avg rent psf: " + avgActiveComps["avgPPSF"].toFixed(2));
    }
    if (avgSoldComps && avgSoldComps["avgPrice"]) {
      subjectCompData.push("recently off-market comps avg monthly rent: " + Math.round(avgSoldComps["avgPrice"]));
      if (avgSoldComps["avgPPSF"]) subjectCompData.push("recently off-market comps avg rent psf: " + avgSoldComps["avgPPSF"].toFixed(2));
    }

    var theActiveComps = []
      .concat([formatRentalPropertyData(subjectProperty, true)])
      .concat(activeComps.map(function (item) { return formatRentalPropertyData(item, false, "active"); }))
      .map(function (property) { return JSON.stringify(property); });

    var theLeasedComps = []
      .concat([formatRentalPropertyData(subjectProperty, true)])
      .concat(soldComps.map(function (item) { return formatRentalPropertyData(item, false, "sold"); }))
      .map(function (property) { return JSON.stringify(property); });

    var prompt = "";
    prompt +=
      "Write a price_overview (Store in JSON Response: price_overview) of about 50 words, one short paragraph, explaining in plain language how the subject rental's suggested monthly rent was derived from comparable rentals (currently listed and recently off market) in " +
      hood + ". Do not state the actual suggested rent. Use the following data as appropriate. \n" +
      subjectCompData.join("\n") + "\n\n";

    if (theActiveComps.length > 1) {
      prompt +=
        "Write a narrative for active rental comps (Store in JSON Response: active_comps) around 80 words. Compare the comps to the subject rental, justifying why a comp rents higher or lower than the suggested rent of " +
        subjectProperty["suggestedPrice"] + "/mo, focusing on size, location, floor, amenities and condition. Use the following data elements as appropriate. \n" +
        theActiveComps.join("\n") + "\n\n";
    } else {
      prompt +=
        "Write a narrative for active rental comps (Store in JSON Response: active_comps) around 80 words noting that no comparable rentals are currently on the market given the uniqueness of the subject, and that further evaluation is needed to set an accurate rent. \n\n";
    }

    // No sold_comps narrative is requested: the off-market page it filled was removed. The
    // off-market comps themselves still reach the model through subjectCompData above, so the
    // price overview can still explain their part in the suggested rent.
    if (theLeasedComps.length > 1) {
      prompt +=
        "For context only, these comparable rentals were recently listed and are no longer on the market; we do not know whether they actually rented or at what price, so never say a unit 'leased' or 'rented' and treat each figure as its last asking rent. Do not write a separate section about them. \n" +
        theLeasedComps.join("\n") + "\n\n";
    }

    var supplyData = (activityResponse || []).map(function (item) {
      return JSON.stringify({ year: item.val.slice(0, 4), new_rentals: item.new_listings && item.new_listings.count ? Math.round(item.new_listings.count) : 0 });
    });

    // Neighborhood-wide, every unit type — NOT the comp set. The prompt used to say "similar
    // properties", which had the copy describing this as a trend for units like the subject.
    prompt +=
      "Write a supply_demand (Store in JSON Response: supply_demand) of about 40 words, one short paragraph, describing the trend in the volume of new rental listings across the whole " +
      hood + " neighborhood — every rental listing there, of every unit type, size and price, not only units comparable to the subject. Say plainly that the figures are neighborhood-wide and cover all rental types. Briefly note a likely driver (seasonality, interest rates, economy). The most recent year is annualized from year-to-date, so treat it as a full-year pace. \n" +
      supplyData.join("\n") + "\n\n";

    var theRentTrendData = (ppsfTrends || []).map(function (item) {
      return JSON.stringify({ year: item.val.slice(0, 4), median_rent: Math.round(item.med_ppsf) });
    });

    prompt +=
      "Write a price_trend (Store in JSON Response: price_trend) of about 40 words, one short paragraph, describing how the median asking rent across the whole " +
      hood + " neighborhood has moved over time — this median covers every rental listing there, of every unit type and size, not only units comparable to the subject, so say so plainly. Add a brief likely driver. \n" +
      theRentTrendData.join("\n") + "\n\n";

    var systemContent =
      "You are a real estate agent helping a landlord understand the market rent for a subject rental unit; the results are narrative for a rental comp report. Format currency as $#,### per month with no decimals. Use a professional but friendly tone, simple terms, and keep every section concise. Comparable rentals that are no longer listed are described as 'recently off market' — we do not know whether they actually rented or at what price, so never use the words 'leased' or 'rented', and treat any off-market figure as the last asking rent.";

    prompt +=
      'The results should be in valid raw JSON format, no formatting. { "price_overview" : "text", "active_comps" : "text", "supply_demand" : "text", "price_trend" : "text" }';

    const queryData = {
      messages: [
        { role: "system", content: systemContent },
        { role: "user", content: prompt }
      ],
      model: "gpt-4.1-mini",
      response_format: { type: "json_object" }
    };

    const axiosData = { url: apiURL + "/ai/chat", method: "post", query: queryData };

    var aiResponse = {};
    try {
      const res = await _axiosCall(axiosData);
      if (res && res.choices && res.choices[0] && res.choices[0].message && res.choices[0].message.content) {
        const result = res.choices[0].message.content;
        try { aiResponse = JSON.parse(result); } catch (e) { }
      }
    } catch (error) {
      console.log("Error generating summary:", error);
    }
    return aiResponse;
  };

  const getComps = async building => {
    var isHouse = _isHouse(building);
    var propertyDetails = compSettings.propertyDetails;
    var property = compSettings.propertyDetails.property ? compSettings.propertyDetails.property : null;
    property = Object.assign(property || {}, propertyDetails);

    // Target rent: user-entered, else subject's last listed rent, else null.
    var userTargetRent =
      compSettings.propertyDetails &&
        compSettings.propertyDetails.customPrice &&
        parseInt(compSettings.propertyDetails.customPrice) > 100
        ? parseInt(compSettings.propertyDetails.customPrice)
        : false;
    var subjectRent = property && property.last_listed_rent_price_all > 0 && property.last_listed_rent_price_all < 100000 ? property.last_listed_rent_price_all : false;
    var expectedRent = userTargetRent || subjectRent || false;

    var bedroomQuery =
      propertyDetails.bedrooms !== "" && parseInt(propertyDetails.bedrooms) > -1 && !isHouse
        ? "bedrooms:" + (propertyDetails.bedrooms == 0 ? "(0 1)" : propertyDetails.bedrooms)
        : "";

    var bathsQuery = propertyDetails.baths > 0 ? "baths:" + propertyDetails.baths + "^3.0" : "";

    var sqFtQuery = _shouldShow(propertyDetails.sq_ft)
      ? " OR sq_ft:[" + Math.round(propertyDetails.sq_ft * 0.8) + " TO " + Math.round(propertyDetails.sq_ft * 1.2) + "]^3.0"
      : "";

    var buildingKeyQuery = _shouldShow(building.key) ? " OR building:" + building.key + "^5.0" : "";

    var neighborhoodQuery = _shouldShow(building.neighborhood)
      ? building.neighborhood.length > 1
        ? ' OR neighborhood:("' + building.neighborhood.join('" "') + '")^1.7'
        : ' OR neighborhood:"' + building.neighborhood + '"^1.7'
      : "";

    var boroughQuery = _shouldShow(building.borough) ? 'borough:"' + building.borough + '"' : false;

    var floorQuery =
      property && _shouldShow(property.floor) && property.floor > 0
        ? " OR floor:[" + parseInt(property.floor * 0.7) + " TO " + parseInt(property.floor * 1.3) + "]^2.5"
        : "";

    var buildingYearQuery = _shouldShow(building.year_built)
      ? " OR year_built:[" + (building.year_built - 10) + " TO " + (building.year_built + 15) + "]^1"
      : "";

    var removeSubject = _shouldShow(property.key) ? "-key:" + property.key : null;

    // Rent price range around the target rent (monthly scale).
    var rentFloorQuery = expectedRent
      ? "[" + Math.round(expectedRent * 0.6) + " TO " + Math.round(expectedRent * 1.5) + "]"
      : "[1000 TO 100000]";

    var activeRentQuery =
      "last_listed_rent_status_all:(active) AND last_listed_rent_price_all:" +
      rentFloorQuery + " AND " + getLastMonthsQuery("last_listed_rent_date_all", 12);

    var leasedRentQuery =
      'last_listed_rent_status_all:(rented closed leased "in contract" "off market") AND last_listed_rent_price_all:' +
      rentFloorQuery + " AND " + getLastMonthsQuery("last_listed_rent_date_all", 24);

    var compMatchQuery =
      (bathsQuery + sqFtQuery + floorQuery + buildingYearQuery + neighborhoodQuery + buildingKeyQuery)
        .replace(/^\s*OR\s+/i, "").trim();

    var compQuery = {
      q: compMatchQuery ? compMatchQuery : "*:*",
      fq: [
        removeSubject,
        boroughQuery,
        "deleted:false",
        "{!geofilt}",
        isHouse ? "" : '-address_2_normalized:""',
        bedroomQuery,
        "-property_type:*commercial*"
      ],
      fl: [
        "full_street_address", "display_full_street_address", "zip", "address_2", "address_2_normalized",
        "floor", "bedrooms", "baths", "half_baths", "current_status", "sq_ft", "exterior_sq_ft",
        "building", "building_name", "neighborhood", "borough", "key", "total_units", "residential_units",
        "last_listed_rent_price_all", "last_listed_rent_date_all", "last_listed_rent_key_all", "last_listed_rent_status_all",
        "id", "div(last_listed_rent_price_all, sq_ft)",
        "owner", "ownership_type", "borough_code", "block", "lot", "year*", "building_class",
        "property_features", "building_features", "score", "geodist()"
      ],
      wt: "json",
      sfield: "geocode",
      pt: building.geocode,
      d: 2,
      sort: "score desc, geodist() asc",
      start: 0,
      rows: 8,
      group: true,
      "group.limit": 20,
      "group.query": [activeRentQuery, leasedRentQuery]
    };

    setFetchInProgress(true);
    var axiosData = { url: apiURL + "/query/we3-properties?cache=60", method: "post", query: compQuery };
    var res = await _axiosCall(axiosData);

    var activeComps = res[activeRentQuery] && res[activeRentQuery].doclist && res[activeRentQuery].doclist.docs ? res[activeRentQuery].doclist.docs : [];
    var soldComps = res[leasedRentQuery] && res[leasedRentQuery].doclist && res[leasedRentQuery].doclist.docs ? res[leasedRentQuery].doclist.docs : [];

    // Suggested monthly rent: user target, else avg rent-PSF x subject sq_ft, else avg comp rent.
    // Only average rent-PSF from comps with a real footprint (sq_ft >= 100) and a
    // sane monthly PSF ($1–$50/SF). This drops sq_ft -1/0 (negative/infinite div())
    // and anomalies like a sale misclassified as a rental that would skew the rent.
    var rentPSFs = activeComps.concat(soldComps)
      .filter(function (item) { return item.sq_ft >= 100; })
      .map(function (item) { return item["div(last_listed_rent_price_all, sq_ft)"]; })
      .filter(function (v) { return v >= 1 && v <= 50; });
    var avgRentPSF = rentPSFs.length ? rentPSFs.reduce(function (a, b) { return a + b; }, 0) / rentPSFs.length : 0;

    var suggestedPrice = userTargetRent
      ? userTargetRent
      : (avgRentPSF && property.sq_ft > 1 ? Math.round(avgRentPSF * property.sq_ft) : false);

    if (!suggestedPrice || suggestedPrice < 500) {
      var allRents = activeComps.concat(soldComps)
        .map(function (c) { return c.last_listed_rent_price_all; })
        .filter(function (v) { return v > 0; });
      suggestedPrice = allRents.length
        ? Math.round(allRents.reduce(function (a, b) { return a + b; }, 0) / allRents.length)
        : (expectedRent || 0);
    }

    // Average days on market from currently-listed comps (days since listed).
    var nowSec = Date.now() / 1000;
    var domVals = activeComps
      .map(function (c) { return c.last_listed_rent_date_all > 0 ? (nowSec - c.last_listed_rent_date_all) / 86400 : null; })
      .filter(function (v) { return v != null && v > 0; });
    var avgDOM = domVals.length ? Math.round(domVals.reduce(function (a, b) { return a + b; }, 0) / domVals.length) : null;

    var trendData = await getRentTrends(building);
    var neighborhoodStats = await getNeighborhoodRentStats(building);

    return {
      suggestedPrice: roundUpToNearest(suggestedPrice, 100),
      latestPrice: subjectRent
        ? { value: subjectRent, date: property.last_listed_rent_date_all ? new Date(property.last_listed_rent_date_all * 1000).toISOString() : null, type: "listed_rent" }
        : { value: 0, date: null },
      priceChange: null,
      comps: { active: activeComps, sold: soldComps },
      domTrends: null,
      avgDOM: avgDOM,
      discountTrends: null,
      avgDiscount: null,
      ppsfTrends: trendData.rentTrend,
      currentCashBuyers: null,
      currentFinancedBuyers: null,
      activityResponse: trendData.activityResponse,
      neighborhoodStats: neighborhoodStats
    };
  };

  // Rental neighborhood trends from listing events (we3-activities-3): new rental
  // listing volume (supply) and median asking rent per year. Replaces the sale-only
  // we3-transactions price/DOM/discount trends.
  const getRentTrends = async building => {
    var q;
    if (building.neighborhood && building.neighborhood.length > 0) {
      q = '(neighborhood:"' + building.neighborhood[0].toLowerCase() + '" AND borough:"' + building.borough.toLowerCase() + '")';
    } else if (building.zip) {
      q = "(zip:" + building.zip + ")";
    } else {
      return { activityResponse: [], rentTrend: [] };
    }

    var axiosData = {
      url: apiURL + "/query/we3-activities-3?cache=60",
      method: "post",
      query: {
        q: q,
        fq: ["hierarchy:[0 TO 2]", "topic:listings", "event_tags:rent", "price:[500 TO 100000]"],
        wt: "json",
        rows: 0,
        "json.facet": {
          by_time: {
            range: {
              field: "time",
              start: "2020-01-01T05:00:00Z",
              end: "NOW",
              gap: "+1YEAR",
              facet: {
                new_listings: { type: "query", q: "event_tags:just-listed" },
                med_rent: "percentile(price,50)"
              }
            }
          }
        }
      }
    };

    var res = await _axiosCall(axiosData);
    var buckets = res && res.facets && res.facets.by_time && res.facets.by_time.buckets ? res.facets.by_time.buckets : [];

    // The current calendar-year bucket only covers Jan 1 -> today, so its raw
    // new-listing count reads as a supply collapse next to full prior years.
    // Scale it up to a full-year run rate and flag it so the chart can mark it.
    var nowMs = Date.now();
    var curYear = new Date(nowMs).getUTCFullYear();
    var yearStartMs = Date.UTC(curYear, 0, 1);
    var elapsedFrac = (nowMs - yearStartMs) / (Date.UTC(curYear + 1, 0, 1) - yearStartMs);

    var activityResponse = buckets.map(function (b) {
      var year = parseInt(String(b.val).slice(0, 4), 10);
      var rawCount = b.new_listings && b.new_listings.count ? b.new_listings.count : 0;
      var projected = year === curYear && elapsedFrac > 0.02 && elapsedFrac < 0.98;
      var count = projected ? Math.round(rawCount / elapsedFrac) : rawCount;
      return { val: b.val, new_listings: { count: count, raw: rawCount }, contract_signed: { count: 0 }, projected: projected };
    });
    var rentTrend = buckets.map(function (b) {
      return { val: b.val, med_ppsf: b.med_rent ? Math.round(b.med_rent) : 0, count: b.count };
    });

    return { activityResponse: activityResponse, rentTrend: rentTrend };
  };

  // Neighborhood rent context for the subject's bedroom count (last 24 months),
  // shown on the front page in place of days-on-market.
  const getNeighborhoodRentStats = async building => {
    const neighborhood = Array.isArray(building.neighborhood) && building.neighborhood.length > 0
      ? building.neighborhood[0]
      : building.neighborhood;
    if (!neighborhood) return null;

    const propertyDetails = compSettings.propertyDetails || {};
    var bedrooms = propertyDetails.bedrooms;
    var bedFilter = "";
    if (bedrooms !== "" && bedrooms !== undefined && bedrooms !== null && parseInt(bedrooms) > -1) {
      bedFilter = " AND bedrooms:" + (parseInt(bedrooms) === 0 ? "(0 1)" : parseInt(bedrooms));
    }

    const rentFilter = "last_listed_rent_price_all:[100 TO 100000] AND " +
      getLastMonthsQuery("last_listed_rent_date_all", 24);

    const axiosData = {
      url: apiURL + "/query/we3-properties?cache=3600",
      method: "post",
      query: {
        q: 'neighborhood:"' + neighborhood.toLowerCase() + '" AND ' + rentFilter + bedFilter,
        fq: ["-deleted:true", '-address_2_normalized:""', "-property_type:*commercial*"],
        wt: "json",
        rows: 0,
        "json.facet": {
          median_rent: "percentile(last_listed_rent_price_all,50)",
          avg_rent: "avg(last_listed_rent_price_all)",
          // PSF facets must exclude anomalies — chiefly sales misclassified as
          // rentals, plus annual-rent-stored-as-monthly, placeholder rents, and
          // bogus tiny sq_ft. Each produces a PSF in the hundreds/thousands; the
          // median shrugs them off but they dragged the average from ~$5 to ~$21.
          // Require a real footprint (sq_ft >= 100) and bound monthly rent-PSF to a
          // sane $1–$50/SF band via frange so both stats run on a clean dataset.
          with_sqft: {
            type: "query",
            q: "sq_ft:[100 TO *]",
            domain: { filter: "{!frange l=1 u=50}div(last_listed_rent_price_all,sq_ft)" },
            facet: {
              median_rent_psf: "percentile(div(last_listed_rent_price_all,sq_ft),50)",
              avg_rent_psf: "avg(div(last_listed_rent_price_all,sq_ft))"
            }
          }
        }
      }
    };

    var res = await _axiosCall(axiosData);
    var f = res && res.facets ? res.facets : {};
    var fSqft = f.with_sqft ? f.with_sqft : {};
    return {
      neighborhood: neighborhood,
      bedrooms: bedrooms,
      medianRent: f.median_rent || null,
      avgRent: f.avg_rent || null,
      medianRentPSF: fSqft.median_rent_psf || null,
      avgRentPSF: fSqft.avg_rent_psf || null,
      count: f.count || 0,
      countWithSqft: fSqft.count || 0
    };
  };

  if (!reportData) return null;

  const {
    subjectProperty,
    avgDiscount,
    activeComps,
    avgActiveComps,
    soldComps,
    avgSoldComps,
    currentCashBuyers,
    currentFinancedBuyers,
    percentCashBuyers,
    percentFinanced,
    activityResponse,
    isCoop
  } = reportData.derivedData;

  const currentDate = new Date();
  const options = { year: "numeric", month: "long" };
  const formattedDate = currentDate.toLocaleDateString("en-US", options);

  const buildingRes = reportData && reportData.buildingRes ? reportData.buildingRes : {};
  var buildingNameOrAdr = "";
  if (buildingRes && buildingRes.name) {
    buildingNameOrAdr = _capitalizeText(buildingRes.name);
  } else if (buildingRes && buildingRes.display_full_street_address) {
    buildingNameOrAdr = _capitalizeText(buildingRes.display_full_street_address);
  } else if (buildingRes && buildingRes.full_street_address) {
    buildingNameOrAdr = _capitalizeText(buildingRes.full_street_address);
  }

  var compUnitSuffix = "";
  if (
    compSettings &&
    compSettings.propertyDetails &&
    compSettings.propertyDetails.property &&
    compSettings.propertyDetails.property.address_2_normalized
  ) {
    compUnitSuffix =
      " - " +
      compSettings.propertyDetails.property.address_2_normalized.toUpperCase().replace("APT ", "");
  }
  var reportTitle = buildingNameOrAdr + compUnitSuffix;

  const nbhd = reportData.compResponse && reportData.compResponse.neighborhoodStats ? reportData.compResponse.neighborhoodStats : null;
  const nbhdBedLabel = nbhd && nbhd.bedrooms !== "" && nbhd.bedrooms !== undefined && nbhd.bedrooms !== null && parseInt(nbhd.bedrooms) > -1
    ? (parseInt(nbhd.bedrooms) === 0 ? " (Studio)" : " (" + parseInt(nbhd.bedrooms) + " Bed)")
    : "";
  const hasProjectedSupply = Array.isArray(activityResponse) && activityResponse.some(function (i) { return i && i.projected; });

  // These two charts are the only part of the report that is NOT comp-matched: getRentTrends
  // queries every rental listing in the subject's neighborhood (zip when it has none), with no
  // bedroom, size or unit-type filter. Saying so on the page stops the trend being read as a
  // trend for units like the subject.
  const trendGeoLabel = Array.isArray(buildingRes.neighborhood) && buildingRes.neighborhood.length > 0
    ? _capitalizeText(buildingRes.neighborhood[0])
    : (buildingRes.neighborhood ? _capitalizeText(buildingRes.neighborhood) : (buildingRes.zip ? "ZIP " + buildingRes.zip : "the neighborhood"));
  const trendScopeNote = trendGeoLabel + " · all rental listings, every unit type and size";

  // Subject property specs shown at the top of the report as visual tiles —
  // bed / bath / interior SF / exterior SF. Prefer the resolved subject property,
  // fall back to the user-entered details.
  const _subjectPropertyDetails = (compSettings && compSettings.propertyDetails) || {};
  const _sp = subjectProperty || {};
  const _subjBedRaw = _shouldShow(_sp.bedrooms) ? _sp.bedrooms : _subjectPropertyDetails.bedrooms;
  const _subjBathRaw = _sp.baths > 0 ? _sp.baths : _subjectPropertyDetails.baths;
  const _subjSqFtRaw = _sp.sq_ft > 1 ? _sp.sq_ft : _subjectPropertyDetails.sq_ft;
  const _subjExtRaw = _sp.offering_exterior_sq_ft > 0 ? _sp.offering_exterior_sq_ft
    : _sp.exterior_sq_ft > 0 ? _sp.exterior_sq_ft
    : _subjectPropertyDetails.exterior_sq_ft > 0 ? _subjectPropertyDetails.exterior_sq_ft
    : null;
  const _subjBedNum = _subjBedRaw !== "" && _subjBedRaw != null && parseInt(_subjBedRaw) > -1 ? parseInt(_subjBedRaw) : null;
  const subjectSpecs = [
    _subjBedNum != null && { value: _subjBedNum === 0 ? "Studio" : _subjBedNum, label: _subjBedNum === 0 ? "Layout" : (_subjBedNum === 1 ? "Bed" : "Beds") },
    _subjBathRaw && parseFloat(_subjBathRaw) > 0 && { value: parseFloat(_subjBathRaw), label: parseFloat(_subjBathRaw) === 1 ? "Bath" : "Baths" },
    _subjSqFtRaw && parseInt(_subjSqFtRaw) > 1 && { value: _formatNumber(_subjSqFtRaw), label: "Interior SF" },
    _subjExtRaw && parseInt(_subjExtRaw) > 1 && { value: _formatNumber(_subjExtRaw), label: "Exterior SF" },
  ].filter(Boolean);

  // helper to render one card inline (not a subcomponent)


  return (
    <>
      <CoverPage
        {...props}
        summarizeGeographies={summarizeGeographies}
        priorYearPeriodName={priorYearPeriodName}
        currentPeriodName={currentPeriodName}
        dateDisplay={formattedDate}
        defaultImage={subjectProperty && subjectProperty.building ? "https://newsapi.marketproof.com/buildings/pictures/" + subjectProperty.building : false}
      />

      <div className="report-container page-section comp-view building-view-3-page-1 rental-comp">
        <SubHeader
          reportData={reportData}
          reportTitle={reportTitle}
          dateDisplay={formattedDate}
          editedContent={editedContent}
        />

        {subjectSpecs.length > 0 && (
          <div className="subject-property-specs">
            {subjectSpecs.map(function (spec, i) {
              return (
                <div className="subject-property-specs__tile" key={i}>
                  <span className="subject-property-specs__value">{spec.value}</span>
                  <span className="subject-property-specs__label">{spec.label}</span>
                </div>
              );
            })}
          </div>
        )}

        <section className="report-section">
          <div className="suggested-price-card">
            <Icon />
            <div className="price-details">
              <p id="labelSuggestedPrice" className="label editable track-original">Suggested Monthly Rent</p>
              {renderEditedOrDefault(
                "suggestedPrice",
                <h2 id="suggestedPrice" className="price editable track-original">
                  {subjectProperty["suggestedPrice"] ? formatRent(subjectProperty["suggestedPrice"]) : "--"}
                </h2>
              )}
            </div>

            <div className="divider"></div>

            <div className="range-details">
              <p id="labelRange" className="label editable track-original">Range</p>
              {renderEditedOrDefault(
                "priceRange",
                <h3 id="priceRange" className="range editable track-original">
                  {subjectProperty["suggestedPriceLow"]
                    ? formatRent(roundUpToNearest(subjectProperty["suggestedPriceLow"], 100)) +
                    " - " +
                    formatRent(roundUpToNearest(subjectProperty["suggestedPriceHigh"], 100))
                    : "--"}
                </h3>
              )}
            </div>
          </div>

          <div className="rental-overview-body">
            {renderEditedOrDefault("howPriceDetermined", <h3 id="howPriceDetermined" className="comp-type-heading">How is the price determined?</h3>)}
            {renderEditedOrDefault("priceOverview", <p id="priceOverview" className="editable track-original">{AiResponse && AiResponse.price_overview ? AiResponse.price_overview : <CustomSkeleton count={4} />}</p>)}

            {renderEditedOrDefault("nbhdMetricsHeading", <h3 id="nbhdMetricsHeading" className="editable comp-type-heading track-original">{"Neighborhood Rent Metrics" + nbhdBedLabel}</h3>)}
            <div className="nbhd-metrics-row">
              <div className="nbhd-metric">
                <span className="nbhd-metric-value">{nbhd && nbhd.medianRent ? "$" + _formatNumber(nbhd.medianRent) + "/mo" : "--"}</span>
                <span className="nbhd-metric-label">Median Asking Rent</span>
              </div>
              <div className="nbhd-metric">
                <span className="nbhd-metric-value">{nbhd && nbhd.avgRent ? "$" + _formatNumber(nbhd.avgRent) + "/mo" : "--"}</span>
                <span className="nbhd-metric-label">Average Asking Rent</span>
              </div>
              <div className="nbhd-metric">
                <span className="nbhd-metric-value">{nbhd && nbhd.medianRentPSF ? formatRentPSF(nbhd.medianRentPSF) : "--"}</span>
                <span className="nbhd-metric-label">Median Rent / SF</span>
              </div>
              <div className="nbhd-metric">
                <span className="nbhd-metric-value">{nbhd && nbhd.avgRentPSF ? formatRentPSF(nbhd.avgRentPSF) : "--"}</span>
                <span className="nbhd-metric-label">Average Rent / SF</span>
              </div>
              <div className="nbhd-metric">
                <span className="nbhd-metric-value">{nbhd && nbhd.count ? _formatNumber(nbhd.count) : "--"}</span>
                <span className="nbhd-metric-label">Rentals Listed (24mo)</span>
              </div>
            </div>

            <div className="rental-trends-row">
              <div className="trend-col">
                {renderEditedOrDefault("supplyDemandHeading", <h3 id="supplyDemandHeading" className="editable comp-type-heading track-original">Rental Supply</h3>)}
                {renderEditedOrDefault("supplyDemandScope", <p id="supplyDemandScope" className="editable track-original trend-scope">{trendScopeNote}</p>)}
                <div className="trend-chart">
                  <MultipleBarCharts
                    data={(activityResponse || []).map(function (item) {
                      return {
                        date: item.val.slice(0, 4) + (item.projected ? "*" : ""),
                        value1: item.new_listings && item.new_listings.count ? Math.round(item.new_listings.count) : 0,
                        value2: 0
                      };
                    })}
                    height={210}
                    isWeekly={dateOptions.gap}
                    secondValue={false}
                    legendNames={{ value1: "New Rental Listings" }}
                  />
                </div>
                {renderEditedOrDefault("supplyDemand", <p id="supplyDemand" className="editable track-original trend-caption">{AiResponse && AiResponse.supply_demand ? AiResponse.supply_demand : <CustomSkeleton count={3} />}</p>)}
                {hasProjectedSupply ? <p className="trend-note">*Most recent year annualized from year-to-date</p> : null}
              </div>

              <div className="trend-col">
                {renderEditedOrDefault("priceTrendsHeading", <h3 id="priceTrendsHeading" className="editable comp-type-heading track-original">Rent Trends</h3>)}
                {renderEditedOrDefault("priceTrendsScope", <p id="priceTrendsScope" className="editable track-original trend-scope">{trendScopeNote}</p>)}
                <div className="trend-chart">
                  <CustomLineChart
                    theme={theme}
                    data={(reportData.compResponse.ppsfTrends || []).map(function (item) { return { date: item.val.slice(0, 4), value: Math.round(item.med_ppsf) }; })}
                    isWeekly={dateOptions.gap}
                    height={210}
                    formatter={function (value) { return "$" + _formatNumber(value); }}
                  />
                </div>
                {renderEditedOrDefault("priceTrendText", <p id="priceTrendText" className="editable track-original trend-caption">{AiResponse && AiResponse.price_trend ? AiResponse.price_trend : <CustomSkeleton count={3} />}</p>)}
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>

      {/* ACTIVE COMPS */}
      <div className="report-container page-section building-view-3-page-1 rental-comp">
        <SubHeader reportData={reportData} reportTitle={reportTitle} dateDisplay={formattedDate} editedContent={editedContent} />
        <div className="vertical-divider"></div>
        <div className="horizontal-divider"></div>
        <div className="border-divider"></div>

        <section className="report-section">
          {renderEditedOrDefault("activeCompsHeading", <h3 id="activeCompsHeading" className="editable comp-type-heading track-original">Comparable properties on the market</h3>)}

          <div className="property-type-values">
            {renderEditedOrDefault("activeCompsText", <p id="activeCompsText" className="editable track-original">{AiResponse && AiResponse.active_comps ? AiResponse.active_comps : <CustomSkeleton count={8} />}</p>)}

            <div className="property-type-numeric-content">
              <div>
                {renderEditedOrDefault("activeAvgPrice", <div id="activeAvgPrice" className="property-type-price editable track-original">{avgActiveComps && avgActiveComps.avgPrice ? formatRent(avgActiveComps.avgPrice) : "--"}</div>)}
                {renderEditedOrDefault("activeAvgPriceLabel", <div id="activeAvgPriceLabel" className="property-asking-price editable track-original">Average Asking Rent</div>)}
              </div>
              <div>
                {renderEditedOrDefault("activeAvgPPSF", <div id="activeAvgPPSF" className="property-type-price editable track-original">{avgActiveComps && avgActiveComps.avgPPSF ? formatRentPSF(avgActiveComps.avgPPSF) : "--"}</div>)}
                {renderEditedOrDefault("activeAvgPPSFLabel", <div id="activeAvgPPSFLabel" className="property-asking-price editable track-original">Average Asking Rent PSF</div>)}
              </div>
            </div>
          </div>

          <div className="property-comparison-container">
            {[
              { original: subjectProperty, formatted: formatRentalPropertyData(subjectProperty, true, "active") },
            ]
              .concat(
                activeComps
                  .slice(0)
                  .sort(function (a, b) { return a["geodist()"] - b["geodist()"]; })
                  .map(function (item) { return { original: item, formatted: formatRentalPropertyData(item, false, "active") }; })
              )
              .map(function (pair, index) {
                var original = pair.original;
                var formatted = pair.formatted;
                return (
                  <PropertyCard
                    key={formatted.id}
                    property={formatted}
                    index={index}
                    isSubject={formatted.isSubject}
                    isSelected={false}
                    showSelectIcon={false}
                    compSource="activeComps"
                    showChangeButton={!formatted.isSubject}
                    linkURL={generateShareLink(original)}
                    openDetailModal={props && props.openDetailModal ? props.openDetailModal : null}
                    renderEditedOrDefault={renderEditedOrDefault}
                  />
                );
              })}


            {activeComps.length <= 0 ? (
              <div className="prpoerty-no-comps">
                {renderEditedOrDefault("noActiveCompsHeading", <h3 id="noActiveCompsHeading" className="editable comp-type-heading track-original">No Comps Available</h3>)}
                {renderEditedOrDefault("noActiveCompsText", <p id="noActiveCompsText" className="editable track-original">Due to the unique nature of the subject property, there are currently no suitable comparable properties on the market.</p>)}
                <div
                  data-comp-key={false}
                  data-comp-type={"active"}
                  className="no-comp-button property-badge comp-chg print-hide badge-comp open-comps"
                >
                  <span className="comp-tag">Choose Comps</span>
                </div>
              </div>
            ) : null}
          </div>
        </section>

        <Footer />
      </div>

      {/* The off-market comps page was removed — the report is a two pager (subject + price
          overview, then on-market comps). Off-market rentals still feed the suggested rent
          math above; they just no longer get a page of their own. */}

    </>
  );
};

export default BlendedLayout;

